module.exports = __webpack_public_path__ + "img/4.3513aec6.png";